import React, { useEffect, useState } from "react";
import "./TestimonialsPage.css";

import ScrollToTopButton from "../HomePage/Scrolltotop/ScrollToTopButton";
import Navbar from "../../components/Navbar/Navbar";
import Bgimage from "../HomePage/Bgimagesection/Bgimage";
import Footer from "../../components/Footer/Footer";
import { Helmet } from "react-helmet-async";

// Images
import Keynote from "../../Assets/Images/TestimonialImages/KEYNOTE.webp";
import d_profile from "../../Assets/Images/TestimonialImages/d_profile.png";
import m_profile from "../../Assets/Images/TestimonialImages/m_profile.png";
import premieronetech from "../../Assets/Images/TestimonialImages/premierOneTech.webp";
import Handmade from "../../Assets/Images/TestimonialImages/Handmadelogo.png";
import Amyraa from "../../Assets/Images/TestimonialImages/amyraa.png";
import edj from "../../Assets/Images/TestimonialImages/edj.jpg";
import PLUS91 from "../../Assets/Images/Clientsreview/Plus91.webp";
import AirigoImg from "../../Assets/Images/Clientsreview/AirigoImgIcon.webp";
import edulauncher from "../../Assets/Images/TestimonialImages/eduLauncher.png";
import edu from "../../Assets/Images/TestimonialImages/edu.png";
import helloJewellers from "../../Assets/Images/Clients/Group 18415.webp";
import ChallengePlus from "../../Assets/Images/Clients/Group 18403.webp";
import synergy from "../../Assets/Images/Clients/Group 1272628298.webp";
import FIKAA from "../../Assets/Images/Clientsreview/Fikaa logo.webp";
import FloatingContactButton from "../../components/ContactUs/FloatingContactButton";
import FloatingWhatsappButton from "../../components/ContactUs/FloatingWhatsappButton";
import AB from "../../Assets/Images/TestimonialImages/AB.webp";
import ajayshukla from "../../Assets/Images/TestimonialImages/ajayshukla.webp";
import abhisheksalvi from "../../Assets/Images/TestimonialImages/abhisheksalvi.webp";
import ayussoni from "../../Assets/Images/TestimonialImages/ayushsoni.webp";
import bhushan from "../../Assets/Images/TestimonialImages/bhushanjagtap.webp";
import ajaysharma from "../../Assets/Images/TestimonialImages/ajaysharma.webp";
import jeetbarot from "../../Assets/Images/TestimonialImages/JEETBAROT.webp";
import sahilkesarkar from "../../Assets/Images/TestimonialImages/sahilkesarkar.webp";
import vrushtiashar from "../../Assets/Images/TestimonialImages/vrushtiashar.webp";
import shridhijain from "../../Assets/Images/TestimonialImages/shridhijain.webp";
import sakshivirulkar from "../../Assets/Images/TestimonialImages/sakshivirulkar.webp";
import yashvishah from "../../Assets/Images/TestimonialImages/yashvishah.webp";
import mohammedismail from "../../Assets/Images/TestimonialImages/mohammedismail.webp";
import zulaikhamoidin from "../../Assets/Images/TestimonialImages/zulaikhamoidin.webp";
import vinaymange from "../../Assets/Images/TestimonialImages/vinaymange.webp";
import ashishsawant from "../../Assets/Images/TestimonialImages/ashishsawant.webp";

const testimonialData = [
  {
    name: "FIKAA",
    image: FIKAA,
    text: `FIKAA - BE Financially Free lauds D-WebBox as transformative
    partners, revolutionizing their tech journey with responsive,
    tailor-made solutions. From overcoming hurdles to proactive
    problem-solving, D-WebBox's dedication has fostered
    collaboration and tangibly improved operations, making them an
    indispensable asset in FIKAA's success story.`,
    link: "https://www.fikaa.in/",
  },
  {
    name: "Amyraa",
    image: Amyraa,
    text: `I'm absolutely delighted with the exceptional service provided by D Web Box! Their team delivered end-to-end solutions that exceeded my expectations. What truly sets them apart, however, is the humility and supportiveness of the founders. They were always available to address my concerns and provided personalized attention throughout the project. Highly recommend D Web Box for any IT solutions - top-notch service and outstanding leadership!`,
    link: "https://amyraa.app/",
  },
  {
    name: "Airigo",
    image: AirigoImg,
    text: `DWEBBOX did an outstanding job creating my website for Airigo
    Multiventures Private Limited. From the start, their team was
    professional, attentive, and incredibly skilled. They listened
    to my ideas and turned them into a beautiful, functional site
    that exceeded my expectations. Their dedication to quality and
    customer satisfaction was evident throughout the entire
    process. I highly recommend DWEBBOX for anyone looking for
    top-notch web development services to bring their vision to
    life and increase presence on the web.`,
    link: "https://airigo.in/",
  },
  {
    name: "PLUS91",
    image: PLUS91,
    text: `A big shoutout to the D-WebBox team for turning our ideas into something truly remarkable. The passion and precision they bring to every detail made this journey effortless and exciting. Deep gratitude to Kushal Shah for leading a team that's not just talented, but genuinely collaborative-and to Karan Nanesha for being the calm in the chaos, always on point with coordination and support.`,
    link: "https://plus91.co/",
  },
  {
    name: "Keynote",
    image: Keynote,
    text: `Partnering with Dwebbox for our website development has been a seamless and
    professional experience. From day one, their team grasped our vision clearly and
    approached the project with the right blend of creativity, technical expertise, and
    strategic thinking. We're extremely satisfied with the outcome and would confidently recommend
    Dwebbox to any company looking for a capable and committed development team.
    `,
    link: "https://keynoteindia.net/",
  },
  {
    name: "Maple Leaf",
    image: Keynote,
    text: `Dwebbox has been a dependable tech partner for us, handling our software and
    operational tech requirements with great efficiency. Though we didn't have a formal
    digital setup to begin with, their team stepped in to help us streamline processes
    and bring much-needed structure to our backend systems. Dwebbox isn't just a vendor—they've become an extended part of our team, and we
    look forward to continuing this collaboration as we grow.`,
  },
  {
    name: "Synergy Experiences",
    image: synergy,
    text: `D-WebBox has been like our go-to digital partner for everything. From making our website and microsites to handling unique digital requirements, game development, and even MIS systems they’ve got it all covered.

The best part is they actually get what we want and come back with creative, practical solutions instead of just standard stuff. Super reliable team, easy to work with, and always deliver on time.

Totally recommend them if you’re looking for a solid digital partner!`,
  },

  {
    name: "Handmade Productions",
    image: Handmade,
    text: `We worked with D-WebBox for our Handmade Productions website and couldn’t be happier. The team was patient, collaborative, and really understood our creative vision. They balanced design with functionality, offered smart suggestions, and were always supportive even when we changed directions. The final site perfectly reflects our brand. Big thanks to Kushal Shah and the team — highly recommended!`,
    link: "https://www.thehandmadeproductions.com/",
  },
  {
    name: "Premier One Tech",
    image: premieronetech,
    text: `Outstanding experience with DWebBox! Their collaboration, consulting, development, and Figma design services were top-notch. The team delivered innovative solutions, seamless development, and user-friendly designs that exceeded our expectations. Easy to communicate with Kushal and team. Highly recommend DWebBox for their expertise and professionalism!`,
    link: "https://www.premieronetech.com/",
  },
  {
    name: "Hello Jewellers",
    image: helloJewellers,
    text: `Understanding the requirement of the client very important of what exactly we need when it comes to making an application or ecosystem and that's what makes Dwebbox a good IT company.`,
  },
  {
    name: "Edulauncher",
    image: edu,
    text: `A big thank you to D Webbox for beautifully designing and developing the Edulauncher website.
    The design is fantastic, and the process was seamless. Special thanks to Sakshi for her prompt support throughout and to Karan for smooth deployment. Highly recommend their services!`,
    link: "https://edulauncher.com/",
  },
  {
    name: "Challenge Plus",
    image: ChallengePlus,
    text: `The service was on time and precise. Thank you for developing the application for Challenge Plus.
    Would like to come back for more!!`,
    link: "https://challengeplus.in/",
  },
  {
    name: "EDJ Creations",
    image: edj,
    text: `We are been working with D-webBox from past 6-7 years and having wonderful experience partnering with them. I love the way they keep transparency in all the work which we get done. All the best team.`,
    link: "http://www.ediamondjewellery.com/",
  },
  {
    name: "Milan Zaveri",
    image: m_profile,
    text: `The team was highly professional, responsive, and delivered exactly what we needed within the agreed timeline. They understood our requirements well and suggested improvements. I’d definitely recommend them to anyone looking for reliable tech partners.`,
  },
  // {
  //   name: "Nidhi Shah",
  //   image: m_profile,
  //   text: `Working with the D-Webbox team has been an excellent experience.`,
  // },
  // {
  //   name: "Shameer Sirajuddin",
  //   image: m_profile,
  //   text: `Very professional team that delivers results. I got my organization website designed and built with them and I'm really satisfied with outcome and overall experience`,
  // },
  // {
  //   name: "Keyur Dhanesha",
  //   image: m_profile,
  //   text: `I had an excellent experience with D-WebBox. Took the time to understand out business needs and provided tailored IT solutions that really improved our efficiency. Thank you team, for, you are highly professional, responsive and knowledgeable.`,
  // },
  // {
  //   name: "Komal Chavan",
  //   image: m_profile,
  //   text: `I recently had the pleasure of working with this them, and I was thoroughly impressed. They were extremely attentive and genuinely eager to learn more about our business process. They actively participated in our discussions, always bringing forward the best solutions for the project. I highly recommend their services!`,
  // },
  // {
  //   name: "Abdullah Moinudeen",
  //   image: m_profile,
  //   text: `I recently worked with Dwebbox to build my e-commerce application, personal website, and an online store — and I couldn’t be happier with the results. From start to finish, their team delivered innovative digital solutions that truly helped scale my online presence. What stood out most was their commitment to blending creativity with functionality. They didn't just build a website — they understood my vision and brought it to life with smart design and seamless usability. Everything—from the clean layout to the secure checkout—was executed with excellence. Communication was smooth and professional throughout the process. The team was responsive, attentive to detail, and always ready to incorporate feedback. Their approach made the development experience stress-free and collaborative. Today, my websites look modern, function flawlessly, and reflect my brand identity perfectly. Thank you, Dwebbox — I highly recommend their services to anyone seeking top-notch digital solutions that drive results.`,
  //   lineClamp: true,
  // },
  // {
  //   name: "Jasmine Shoukat Ali",
  //   image: m_profile,
  //   text: `I am extremely satisfied with D-WebBox for setting up my online shopping website (e-commerce) for my self business. Their team showed keen attention to every detail and had a friendly and patient approach throughout the process. They not only delivered exactly what I wanted but also guided me with a better approach to make my e-commerce site more efficient and user-friendly. I truly appreciate their professionalism and dedication, highly recommended`,
  // },
  // {
  //   name: "Pradyumn Dalmia",
  //   image: m_profile,
  //   text: `DWEBBOX did an outstanding job creating my website for Airigo Multiventures Private Limited. From the start, their team was professional, attentive, and incredibly skilled. They listened to my ideas and turned them into a beautiful, functional site that exceeded my expectations. Their dedication to quality and customer satisfaction was evident throughout the entire process. I highly recommend DWEBBOX for anyone looking for top-notch web development services to bring their vision to life and increase presence on the web`,
  // },
  // {
  //   name: "Parth Kotak",
  //   image: m_profile,
  //   text: `D Web Box, led by Kushal, does a fantastic job. Professional, reliable, and creative — they truly understand client needs and deliver beyond expectations. Highly recommended!`,
  // },
  // {
  //   name: "Nitish Upadhyay",
  //   image: m_profile,
  //   text: `A big thank you to D Webbox for beautifully designing and developing the Edulauncher website. The design is fantastic, and the process was seamless. Special thanks to Sakshi for her prompt support throughout and to Karan for smooth deployment. Highly recommend their services!`,
  // },
  // {
  //   name: "Darshan Gandhi",
  //   image: m_profile,
  //   text: `The service was on time and precise. Thank you for developing the application for Challenge Plus. Would like to come back for more!!`,
  // },
  {
    name: "Ashish Sawant",
    image: ashishsawant,
    text: `The colleagues at D-WebBox are a group of dedicated, skilled, and passionate professionals who bring their best to every project.`,
    link: "https://share.google/aVb5myxARY31QfpOg",
  },
  {
    name: "Shridhi Jain",
    image: shridhijain,
    text: `I love the company and what they stand for`,
    link: "https://share.google/KgMtmpKh3TJUrQaMx",
  },
  {
    name: "Ajay Sharma",
    image: ajaysharma,
    text: `Awesome`,
    link: "https://share.google/KG0R7aZhGzniaK6Sq",
  },
  {
    name: "Sakshi Virulkar",
    image: sakshivirulkar,
    text: `Pleasant experience working with a supportive team.`,
    star: 4,
    link: "https://share.google/XGgA8fvcJ2wB64if3",
  },
  // {
  //   name: "Yashvi Shah",
  //   image: yashvishah,
  //   text: ``,
  // },
  // {
  //   name: "Abhishek salvi",
  //   image: abhisheksalvi,
  //   text: ``,
  // },
  // {
  //   name: "Sahil Kesarkar",
  //   image: sahilkesarkar,
  //   text: ``,
  // },
  // {
  //   name: "Vinay Mange",
  //   image: vinaymange,
  //   text: ``,
  // },
  // {
  //   name: "JEET BAROT",
  //   image: jeetbarot,
  //   text: ``,
  // },
  // {
  //   name: "Ayush soni",
  //   image: ayussoni,
  //   text: ``,
  // },
  // {
  //   name: "AB",
  //   image: AB,
  //   text: ``,
  // },
  // {
  //   name: "ajay shukla",
  //   image: ajayshukla,
  //   text: ``,
  // },
  // {
  //   name: "Bhushan Jagtap",
  //   image: bhushan,
  //   text: ``,
  // },
  // {
  //   name: "Vrushti Ashar",
  //   image: vrushtiashar,
  //   text: ``,
  // },
  // {
  //   name: "Zulaikha Moidin",
  //   image: zulaikhamoidin,
  //   text: ``,
  // },
  // {
  //   name: "Mohammed Ismail",
  //   image: mohammedismail,
  //   text: ``,
  // },
];

function TestimonialsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [expandedIndex, setExpandedIndex] = useState(null);

  return (
    <div style={{ background: "#181818" }}>
      <Helmet>
        <title>Client Testimonials | What People Say About Dwebbox</title>
        <meta
          name="description"
          content="Read reviews from our global clients. Discover why businesses trust Dwebbox for MERN stack, mobile apps, and AI development services."
        />
        <link rel="canonical" href="https://dwebbox.com/testimonials" />
        {/* Breadcrumb Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://dwebbox.com"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Testimonials",
                "item": "https://dwebbox.com/testimonials"
              }
            ]
          })}
        </script>
      </Helmet>
      <FloatingContactButton />
      <FloatingWhatsappButton />
      <ScrollToTopButton />
      <Navbar />
      <div className="TestimonialPageHeading">
        <div className="TestimonialBannerHeading">
          <div className="TestimonialPagePara">
            <div className="TestimonialPageDot"></div>
            <p>Testimonials</p>
          </div>
          <h1>What our clients say about us.</h1>
        </div>
      </div>
      <div className="all-testimonials-container">
        <div className="testimonial-grid">
          {testimonialData.map((item, index) => {
            const totalStars = item.star ?? 5;
            return (
              <a
                key={index}
                href={item.link || "#"}
                className={`testimonial-card ${!item.link ? "no-link" : ""}`}
                target={item.link ? "_blank" : "_self"}
                rel={item.link ? "noopener noreferrer" : ""}
              >
                <div className="testimonial-top-row">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="testimonial-logo-top"
                  />
                  <div className="ratings">
                    {[...Array(totalStars)].map((_, i) => (
                      <svg
                        key={i}
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        width="30"
                        height="30"
                      >
                        <path
                          fill="#FFD700"
                          d="M12 2 l2.3 7.0 h7.1l-5.7 4.1 2.2 6.8-5.9-4.3-5.9 4.3 2.2-6.8-5.7-4.1h7.1z"
                        />
                      </svg>
                    ))}
                  </div>
                </div>
                {item.text && (
                  <>
                    <p
                      className={`testimonial-text ${
                        item.lineClamp && expandedIndex !== index
                          ? "clamped"
                          : ""
                      }`}
                    >
                      "{item.text}"
                    </p>

                    {item.lineClamp && (
                      <span
                        className="read-more"
                        onClick={(e) => {
                          e.preventDefault();
                          setExpandedIndex(
                            expandedIndex === index ? null : index
                          );
                        }}
                      >
                        {expandedIndex === index ? "Read less" : "Read more"}
                      </span>
                    )}
                  </>
                )}

                <p
                  className={`firstheading-portfolio ${
                    item.link ? "clickable-name" : ""
                  }`}
                >
                  – {item.name}
                </p>
              </a>
            );
          })}
        </div>
      </div>
      <Bgimage />
      <Footer />
    </div>
  );
}

export default TestimonialsPage;
